export enum DeferOptions {
  Today = 'Today',
  Future = 'Future',
}
